<template>
    <v-container fluid>   
      <h1>PRÓXIMAMENTE...</h1>
      
    </v-container>
</template>

<script>
export default {
  name: 'TestModule',
  components: {
  },

  data () {
      return { 
      }
    },
  mounted: function ()  {

  },
  methods: {
  }
  }
</script>